import {EnvironmentProvider} from 'providers/EnvironmentProvider'
import {OrderDetailsProvider} from 'providers/OrderDetailsProvider'
import {OrderProvider} from 'providers/OrderProvider'
import {Queries} from 'providers/Queries'
import {Theme} from 'providers/Theme'
import {TimeoutProvider} from 'providers/TimeoutProvider'
import {Toaster} from 'providers/Toaster'
import {View} from './View'

export const Cart = () => {
  return (
    <Toaster>
      <EnvironmentProvider>
        <Theme>
          <OrderDetailsProvider>
            <Queries>
              <OrderProvider>
                <TimeoutProvider showTimeoutScreen>
                  <View />
                </TimeoutProvider>
              </OrderProvider>
            </Queries>
          </OrderDetailsProvider>
        </Theme>
      </EnvironmentProvider>
    </Toaster>
  )
}
